<template>
    <div @click="showTitle = false" class="box">
        <span v-show="showTitle" class="titleClass">
            {{placeholder}}
        </span>
        <select
            @change="selectOption($event)"
            class="input-select"
            :value="placeholder"
            v-model="key"
            :placeholder="placeholder" >
            <option
                v-for="(optionVal, index) in parseRadioOptions(options)"
                :key="index"
                :label="optionVal"
                :value="optionVal">
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "FilterSelectComponent",
    props: {
        placeholder: {},
        options: {}
    },
    data(){
        return {
            name: "",
            input: "",
            key: "",
            showTitle: true
        }
    },
    mounted(){
    },
    methods:{
        parseRadioOptions(val){
            const newOptions = []
            const options = JSON.parse(val);
            options.forEach(item => newOptions.push(item.status))
            return newOptions
        },
        selectOption(event){
            const output = {
                "field": this.placeholder,
                "value":this.key
            }
            this.$emit('setFilterSelect', JSON.stringify(output))
        }
    }
}
</script>

<style lang="scss" scoped>
    .input-select{
        width: 100%;
        background-color: #FFF;
        box-sizing: border-box;
        color: #606266;
        padding: 0 15px;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
    }
    .box{
        position: relative;
    }
    .titleClass{
        position: absolute;
        color: #999;
        padding: 7px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyReportComponents/FilterSelectComponent.vue